export default "__VITE_ASSET__BTbRZ6Rl__"